import { render } from "./feedback.component.vue?vue&type=template&id=7fc7a86a"
import script from "./feedback.component.vue?vue&type=script&lang=js"
export * from "./feedback.component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__